export default __webpack_public_path__ + "src/assets/icn-innovation.352719e8e59eb80a7eac8de06f652c72.svg";